import { WEATHERCAM_TIME_LAPSE_CONTROL_ACTION } from '../actions/weatherCamTimeLapseControlActions';

const initialState = {
    timelapsePlayerInitiated: false,
};

export function weatherCamTimeLapseControl(state = initialState, action)
{
    switch (action.type)
    {
        case WEATHERCAM_TIME_LAPSE_CONTROL_ACTION:
        {
            return {
                ...state,
                timelapsePlayerInitiated: action.payload.timelapsePlayerInitiated,
                timelapsePlayerImageIndex: action.payload.currentTimeLapseImageIndex,
                timelapseAction: action.payload.timelapseAction
            };
        }
    }

    return state;
}

